// Rutas de mantenimiento fusionadas en configRoutes.jsx
// Este archivo se mantiene vacío por compatibilidad con App.jsx
export const maintenanceRoutes = [];
